import { promisifyRoutine } from 'redux-saga-routines'
import { createRoutine } from '../../utils/routines'

export const recoverPasswordRoutine = createRoutine('password/RECOVERY')
export const createRecoverPasswordPromise = promisifyRoutine(recoverPasswordRoutine)

export const resetPasswordRoutine = createRoutine('password/RESET')
export const createResetPasswordPromise = promisifyRoutine(resetPasswordRoutine)
